import { useLocalPrice } from "../hooks/useLocalPrice";
import { useTranslation } from "react-i18next";



export default function HowItWorks() {
  const { bracket: localEstimate } = useLocalPrice(1.99, "USD");
  const { t } = useTranslation();

  const STEPS = [
  {
    number: "01",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: t("how_it_works.step1_title"),
    body: t("how_it_works.step1_body", { localEstimate: localEstimate ? ` ${localEstimate}` : "" }),
  },
  {
    number: "02",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M8 2v4M16 2v4M2 10h20"/>
      </svg>
    ),
    title: t("how_it_works.step2_title"),
    body: t("how_it_works.step2_body"),
  },
  {
    number: "03",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38"/>
      </svg>
    ),
    title: t("how_it_works.step3_title"),
    body: t("how_it_works.step3_body"),
  },
];


  return (
    <section id="how-it-works" className="py-16 sm:py-20 border-t border-border/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="mb-12">
          <h2
            className="text-4xl sm:text-5xl font-bold uppercase tracking-tight mb-2"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            {t("how_it_works.heading")}
          </h2>
          <p className="text-muted-foreground text-base max-w-lg">
            {t("how_it_works.subheading")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
          {STEPS.map((step) => (
            <div key={step.number} className="flex flex-col gap-4">
              {/* Step number + icon */}
              <div className="flex items-center gap-3">
                <span
                  className="text-5xl font-extrabold text-muted-foreground/30 leading-none select-none"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  {step.number}
                </span>
                <div className="w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shrink-0">
                  {step.icon}
                </div>
              </div>
              <div>
                <h3
                  className="text-xl font-bold uppercase mb-2"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{step.body}</p>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
